import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Stack, Box, Button, Card, IconButton, InputBase, Avatar, Dialog, DialogTitle, DialogContent, TextField, MenuItem, DialogActions, Typography, TableContainer, Paper, Table, TableHead, TableCell, TableBody, TableRow, Switch, Popover, DialogContentText, CircularProgress, Input, FormControl, InputLabel, Select, OutlinedInput, Chip, Tabs, Tab, Grid } from '@mui/material';
import Iconify from 'src/components/iconify';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { getData, patchData, postData, putData, uploadFile } from 'src/webService/webService';
import { toast } from 'react-toastify';
import PaginationComponent from 'src/components/pagination';

function SEO() {

    const label = { inputProps: { 'aria-label': 'Switch demo' } };
    // const [showGoogleEvents, setShowGoogleEvents] = useState(true);
    const [open, setOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);
    const [dailyData, setDailyData] = useState("");
    const [details, setDetails] = useState(false);
    const [scroll, setScroll] = useState('paper');
    const descriptionElementRef = useRef(null);
    const [allUpdates, setAllUpdates] = useState([]);
    const [view, setView] = useState([]);
    const [selectedLead, setSelectedLead] = useState("");
    const [formOpen, setFormOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [convertForm, setConvertForm] = useState(false);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [seoType, setSeoType] = useState("Google Business Profile");

    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [selectedWorkUpdateId, setSelectedWorkUpdateId] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState({});
    const [fileUpload, setFileUpload] = useState(null);
    const [assignedLeads, setAssignedLeads] = useState([]);

    const sessionToken = sessionStorage.getItem("Token");
    const role = sessionStorage.getItem("role");
    const roleType = sessionStorage.getItem("roleType");
    const serviceTeamType = sessionStorage.getItem("serviceTeamType");
    const UserId = sessionStorage.getItem('userId');
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [seoId, setSeoId] = useState("");
    const [openReminderDialog, setOpenReminderDialog] = useState(false);
    const [selectedReminder, setSelectedReminder] = useState(null);
    const [reminderId, setReminderId] = useState(null);
    const [seoUpdateId, setSeoUpdateId] = useState(null);

    const [seoData, setSEOData] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [events, setEvents] = useState([]);
    console.log(view, "Viewwwwww")
    const [formData, setFormData] = useState({
        completedKeywords: '',
        fileUpload: "",
        progress: '',
        status: "",
        contentStatus: '',
        comments: ''
    });

    const [editData, setEditData] = useState({
        seoType: [],
        businessProfileAvailability: "",
        websiteAvailability: "",
        websiteDuration: "",
        businessProfileDuration: "",
        targetLocation: "",
        targetKeywords: "",
        totalKeywords: "",
        backlinkStatus: "",
        seoPackageType: "",
        assignedTo: "",
        amount: "",
        paymentStatus: ""
    })

    const [convertData, setConvertData] = useState({
        generalStatus: "",
        serviceName: "",
        seoType: seoType,
        assignedUser: "",
        assignedTo: [],
        serviceStatus: "",
        employeeWork: {},
        noOfPosters: [],
        deadline: [],
        status: []
    });

    const handleMultiSelectChange = (event) => {
        const {
            target: { value },
        } = event;
        setConvertData((prev) => ({
            ...prev,
            assignedTo: typeof value === 'string' ? value.split(',') : value,
        }));
    };

    console.log(view, "View");


    const handleOpenMenu = (event, task, id, workUpdateId) => {
        debugger
        let lead;

        if (task && typeof task === 'object') {
            lead = task;
            setSelectedLead(lead);
        }
        else {
            lead = assignedLeads.find((data) => data._id === id);
            setSelectedLead(lead);
        }

        if (event?.currentTarget) {
            setOpenMenu(event.currentTarget);
            setSelectedLeadId(id);
            setSelectedWorkUpdateId(workUpdateId);
            setView(lead || task);
        }

    };

    const handleCloseMenu = () => {
        setOpenMenu(null);
    };

    const handleOpenDialog = async () => {
        await getAllUpdatesAdmin();
        // const filteredView = view.filter(item => item.userDetails[0]?._id === selectedLeadId);
        // setView(filteredView);
        setDetails(true);
        handleCloseMenu();
    };

    const handleCloseDialog = () => {
        setDetails(false);
    };

    const handleOpen = async () => {
        setFormOpen(true);
        handleCloseMenu();
    };

    const handleClose = () => {
        setFormOpen(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleServiceChange = (e) => {
        const { name, value } = e.target;
        setEditData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleOpenEdit = async (id) => {
        getLeadById(id);
        setEditOpen(true);
        handleCloseMenu()
    };

    const handleCloseEdit = () => {
        setEditOpen(false);
    };

    const handleFormOpen = async (leadId) => {
        await getAllUsers();
        setSelectedLeadId(leadId);
        setConvertForm(true);
        setOpen(false);
    };

    const handleFormClose = () => {
        setConvertForm(false);
    };

    const getLeadById = async (id) => {
        debugger
        try {
            const response = await getData(`leads/lead/${id}`, {}, sessionToken);
            if (response?.status === 200) {
                const leadData = response?.data?.seoHistory;
                const initialFormData = {
                    seoType: leadData[0]?.seoType,
                    businessProfileAvailability: leadData[0]?.businessProfileAvailability,
                    websiteAvailability: leadData[0]?.websiteAvailability,
                    websiteDuration: leadData[0]?.websiteDuration.split('T')[0],
                    businessProfileDuration: leadData[0].businessProfileDuration.split('T')[0],
                    targetLocation: leadData[0]?.targetLocation,
                    targetKeywords: leadData[0]?.targetKeywords,
                    totalKeywords: leadData[0]?.totalKeywords,
                    backlinkStatus: leadData[0]?.backlinkStatus,
                    seoPackageType: leadData[0]?.seoPackageType,
                    amount: leadData[0]?.amount,
                    paymentStatus: leadData[0]?.paymentStatus,
                };
                setSeoId(leadData?.[0]?._id)
                setEditData(initialFormData)
                console.log(initialFormData)
            }
        } catch (error) {
            console.error("Error fetching lead details:", error);
            toast.error(`Failed to load lead details ${error ? error : ''}`);
        }
    }

    const handleSubmit = async () => {
        debugger;
        try {
            const response = await patchData(`seo/seo/${seoId}`, editData, sessionToken);
            if (response.status === 200) {
                toast.success("SEO details updated successfully!");
            } else {
                throw new Error(response.message || "Failed to update SEO details");
            }
            setEditOpen(false);
            fetchAssignedLeads();
        } catch (error) {
            console.error("Error updating service:", error);
            toast.error(`${error ? error : ''}` || "Failed to update service details");
        }
    };

    const toggleSeoType = () => {
        setSeoType(prev => prev === "Google Business Profile" ? "Website SEO" : "Google Business Profile");
        setConvertData(prev => ({
            ...prev,
            seoType: seoType === "Google Business Profile" ? "Website SEO" : "Google Business Profile"
        }));
    };

    const getAllUsers = async () => {
        debugger
        try {
            const params = { page: 1, limit: 1000 }
            const response = await getData("users/users", params);
            const filteredUsers = response.data.results.filter(user =>
                user.serviceTeamType && user.serviceTeamType.includes("SEO")
            );

            const formattedOptions = filteredUsers.map(user => ({
                id: user._id,
                name: user.name
            }));

            setEmployeeOptions(formattedOptions);
            console.log(formattedOptions, "Employee options")
        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error(`Failed to load users ${error ? error : ''}`);
        }
    };

    const convertLeads = async () => {
        try {
            const params = {
                serviceName: ["SEO"],
                assignedTo: convertData.assignedTo,
                // seoType: seoType
                employeeWork: convertData.employeeWork,
                serviceStatus: "In Progress",
                noOfPosters: convertData.noOfPosters,
                deadline: convertData.deadline,
                status: convertData.status

            };

            const response = await putData(`leads/lead/${selectedLeadId}/status`, params, sessionToken);

            if (response.status === 200) {
                setConvertForm(false);
                toast.success("Lead Assigned successfully!");
            } else {
                toast.error("Failed to assign lead.", response?.message);
            }
        } catch (error) {
            console.error("Error while assigning lead:", error);
            toast.error(`Something went wrong while assigning the lead. ${error ? error : ''}`);
        }
    };

    const fetchAssignedLeads = async () => {
        debugger
        try {
            let response;
            let seoLeads = [];

            if (role === "Admin" || roleType === "Team Leader") {
                const params = { page: currentPage, limit: limit, serviceName: "SEO", seoType: seoType }
                response = await getData("leads/services", params, sessionToken);
                seoLeads = response.data.results[0].paginatedResults;
                setTotalPages(response.data.results[0].totalPages)
                setTotalCount(response.data.results[0].totalCount)

            } else if (roleType === "Employee") {
                const params = {
                    page: currentPage,
                    limit: limit
                };

                const endpoint = `leads/leads/${UserId}`;

                response = await getData(endpoint, params, sessionToken);

                if (roleType === "Employee" && response?.data) {
                    const leadsData = Array.isArray(response.data)
                        ? response.data[0]?.paginatedResults
                        : response.data[0]?.paginatedResults || [];

                    seoLeads = leadsData.filter(lead =>
                        lead.seoHistory?.some(seo =>
                            seo.seoType?.some(type => seoType.includes(type))
                        )
                    );
                    const totalRecords = response?.data?.[0]?.totalCount?.totalItems;
                    setTotalPages(response.data[0].totalPages === null ? 0 : response.data[0].totalPages);
                    setTotalCount(totalRecords);

                }
            }
            console.log(seoLeads);
            setAssignedLeads(seoLeads);
            console.log(seoLeads, "SEO")
            debugger
            const latestDeadlines = {};
            seoLeads.forEach(lead => {
                const leadId = lead._id;
                const seoData = lead.seoHistory;
                const deadline = seoData?.websiteDuration ||
                    seoData?.businessProfileDuration ||
                    seoData?.createdAt;

                if (deadline && (!latestDeadlines[leadId] || new Date(deadline) > new Date(latestDeadlines[leadId].deadline))) {
                    latestDeadlines[leadId] = { ...lead, deadline };
                }
            });

            const latestDeadlinesArray = Object.values(latestDeadlines);

            const deadlineEvents = latestDeadlinesArray.map(lead => ({
                id: lead._id + '-deadline',
                title: `SEO Progress: ${lead.seoHistory?.seoType?.join(', ') || 'SEO'}`,
                start: lead.deadline,
                allDay: true,
                extendedProps: {
                    type: 'deadline',
                    leadName: lead.name,
                    contentType: lead.seoHistory?.seoPackageType,
                    progress: lead.seoHistory?.progress
                        ? `${Math.round(lead.seoHistory.progress)}%`
                        : '0%'
                },
                backgroundColor: '#FF8A80',
                borderColor: '#FF8A80',
                textColor: '#000'
            }));

            const reminderEvents = [];
            seoLeads.forEach(lead => {
                const reminders = lead.seoHistory?.reminders || [];

                reminders.forEach((reminder, index) => {
                    if (reminder.reminderDate && reminder.status !== "Completed") {
                        const shortMessage = reminder.message
                            ? reminder.message
                            : 'Reminder';
                        const reminderId = reminder._id ? reminder._id : null
                        reminderEvents.push({
                            id: `${lead._id}-reminder-${index}`,
                            reminderId: reminderId,
                            title: `${shortMessage}`,
                            start: reminder.reminderDate,
                            allDay: true,
                            extendedProps: {
                                type: 'reminder',
                            },
                            backgroundColor: '#64B5F6',
                            borderColor: '#64B5F6',
                            textColor: '#000'
                        });
                    }
                });
            });

            console.log("Reminder Events:", reminderEvents);
            setEvents(prevEvents => [...prevEvents, ...deadlineEvents, ...reminderEvents]);

        } catch (err) {
            console.error("Error while fetching SEO Team:", err);
            toast.error(`Failed to load SEO Team.${err ? err : ''}`);
        }
    };

    const getDailyUpdates = async () => {
        try {
            const response = await getData(`dailyworkupdates/user/${UserId}`, {}, sessionToken);
            setDailyData(response?.data);
        } catch (err) {
            console.error("Error while fetching daily updates:", err);
            toast.error(`Failed to load daily updates. ${err ? err : ''}`);
        }
    };

    const getAllUpdatesAdmin = async () => {
        const params = {
            page: 1,
            limit: 1000
        };

        try {
            const response = await getData("dailyworkupdates/updates", params, sessionToken);
            const filteredData = response?.data[0]?.paginatedResults?.filter(
                lead => lead.serviceName === "SEO" && lead.seoType === seoType
            );
            setAllUpdates(filteredData);
            // setView(filteredData);
        } catch (err) {
            console.error("Error while fetching updates:", err);
            toast.error(`Failed to load updates. ${err ? err : ''}`);
        }
    };

    const handleFileChange = (event, leadId) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
            handleFileUpload(file, leadId);
        }
    };

    const handleReminderClick = (eventClickInfo) => {
        const event = eventClickInfo.event;
        if (event.extendedProps.type === 'reminder') {
            const leadId = event.id.split('-reminder-')[0];
            const lead = assignedLeads.find(l => l._id === leadId);
            setReminderId(event.extendedProps.reminderId);
            setSeoUpdateId(lead?.seoHistory?._id)
            setSelectedReminder({
                leadId,
                leadName: lead?.name || 'Unknown',
                seoType: lead?.seoHistory?.seoType.map((item) => item) || 'N/A',
                seoPackageType: lead?.seoHistory?.seoPackageType || 0,
                totalKeywords: lead?.seoHistory?.totalKeywords || 0,
                completedKeywords: lead?.seoHistory?.completedKeywords || 0,
                completionPercentage: lead?.seoHistory?.completionPercentage || 0,
                businessProfileDeadline: lead?.seoHistory?.businessProfileDuration ? new Date(lead.seoHistory.businessProfileDuration).toLocaleDateString() : 'N/A',
                websiteDuration: lead?.seoHistory?.websiteDuration ? new Date(lead.seoHistory.websiteDuration).toLocaleDateString() : 'N/A',
                createdAt: lead?.seoHistory?.createdAt ? new Date(lead.seoHistory.createdAt).toLocaleDateString() : 'N/A',
                updatedAt: lead?.seoHistory?.updatedAt ? new Date(lead.seoHistory.updatedAt).toLocaleDateString() : 'N/A',
                status: lead?.seoHistory?.status || 'N/A',
                reminderMessage: event.title,
                reminderDate: event.start ? new Date(event.start).toLocaleDateString() : 'N/A'
            });
            setOpenReminderDialog(true);
        }
    };

    const handleCloseReminderDialog = () => {
        setOpenReminderDialog(false);
        setSelectedReminder(null);
    };

    const handleMarkReminderCompleted = async () => {
        try {
            const lead = assignedLeads.find(l => l._id === selectedReminder.leadId);
            if (!lead) {
                toast.error("Lead not found!");
                return;
            }

            const response = await postData(`reminder/seo/${seoUpdateId}/${reminderId}`, {}, sessionToken);
            if (response?.status === 200) {
                toast.success("Reminder marked as completed!");
                setOpenReminderDialog(false);
                setSelectedReminder(null);
                await fetchAssignedLeads();
            } else {
                throw new Error(response?.message || "Failed to mark reminder as completed.");
            }
        } catch (error) {
            console.error("Error marking reminder as completed:", error);
            toast.error(`Operation failed: ${error}`);
        }
    };

    const handleFileUpload = async (fileupload, leadId) => {
        const formDataToSend = new FormData();
        formDataToSend.append("file", fileupload);

        try {
            const response = await uploadFile(`files/upload/${selectedLeadId}`, formDataToSend);
            if (response?.status === 200) {
                toast.success("File uploaded successfully!");
                setFileUpload(response?.data);
                setFormData(prevState => ({
                    ...prevState,
                    fileupload: response?.data,
                }));
            } else {
                toast.error("File upload failed!", response?.message);
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error(`Error uploading file. ${error ? error : ''}`);
        }
    };

    const postDailyWorkUpdate = async () => {
        try {
            const checkResponse = await getData(`dailyworkupdates/${selectedLeadId}`, {}, sessionToken);
            const existingUpdates = checkResponse?.data?.map(update => update?.seoHistory?.map(history => history?.dailyUpdateId));

            const seoType = selectedLead?.seoHistory?.[0]?.seoType ||
                selectedLead?.seoHistory?.[0]?.seoType ||
                {};
            const seoPackageType = selectedLead?.seoHistory?.[0]?.seoPackageType ||
                selectedLead?.seoHistory?.[0]?.seoPackageType ||
                {};
            const targetKeywords = selectedLead?.seoHistory?.[0]?.targetKeywords ||
                selectedLead?.seoHistory?.[0]?.targetKeywords ||
                {};
            const totalKeywords = selectedLead?.seoHistory?.[0]?.totalKeywords ||
                selectedLead?.seoHistory?.[0]?.totalKeywords ||
                {};

            const seoHistory = selectedLead?.seoHistory?.[0] ||
                selectedLead?.seoHistory ||
                {};
            const previousCompleted = seoHistory.completedKeywords || 0;
            const newCompleted = parseInt(formData.completedKeywords, 10) || 0;
            const totalCompleted = previousCompleted + newCompleted;

            const status = selectedLead?.seoHistory?.[0]?.completedKeywords === selectedLead?.seoHistory?.[0]?.totalKeywords ? "Completed" : "In Progress";

            const payLoad = {
                totalKeywords,
                seoPackageType,
                targetKeywords,
                completedKeywords: totalCompleted,
                fileUpload: fileUpload,
                status,
                // contentStatus: formData.contentStatus,
                comments: formData.comments,
                serviceName: "SEO",
                seoType,
                leadId: selectedLeadId,
                userId: UserId
            };

            let response;

            if (existingUpdates.length === 0) {
                response = await postData('dailyworkupdates', payLoad, sessionToken);
            } else {
                const updateId = existingUpdates[existingUpdates.length - 1];
                response = await putData(`dailyworkupdates/dailyworkupdates/${updateId}`, payLoad, sessionToken);
            }

            if (response?.status === 200) {
                toast.success("Daily Work Updated Successfully!");
                handleClose();
                getDailyUpdates();
            } else {
                throw new Error(response?.message || "Failed to update Daily Work.");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error(`${error ? error : ''}`);
        }
    };

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        if (currentPage === 1) {
            setLimit(event.target.value)
            fetchAssignedLeads(1, event.target.value)
        }
        else {
            setCurrentPage(1);
            setLimit(event.target.value);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            fetchAssignedLeads(currentPage - 1, limit);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
            fetchAssignedLeads(currentPage + 1, limit);
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    useEffect(() => {
        getAllUsers();
        getAllUpdatesAdmin();
        fetchAssignedLeads(currentPage, limit);
        if (roleType === "Employee") {
            getDailyUpdates(currentPage, limit);
        }
    }, [role, roleType, serviceTeamType, seoType]);

    return (
        <>
            <Helmet>
                <title>Service | SEO Team</title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        SEO Team - {seoType}
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        {/* <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box> */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            {(role === "Admin" || roleType === "Team Leader") && (
                                <Tabs
                                    value={activeTab}
                                    onChange={(e, newValue) => setActiveTab(newValue)}
                                    aria-label="SEO views"
                                >
                                    <Tab label="Calendar View" />
                                    <Tab label="Table View" />
                                </Tabs>
                            )}
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                {/* <Typography variant="body1" sx={{ mr: 1 }}>Google SEO</Typography> */}
                                <Switch
                                    title={seoType === "Website SEO" ? "Want to switch Google Business Profile" : "Want to switch Website SEO"}
                                    checked={seoType === "Website SEO"}
                                    onChange={toggleSeoType}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Stack>

                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
                    {(role === "Admin" || roleType === "Team Leader") && activeTab === 0 && (
                        <Box sx={{ height: 500 }}>
                            <FullCalendar
                                plugins={[dayGridPlugin, interactionPlugin]}
                                initialView="dayGridMonth"
                                headerToolbar={{
                                    start: "",
                                    center: 'prev title next',
                                    end: ""
                                }}
                                events={[...events]}
                                eventContent={renderEventContent}
                                eventClick={handleReminderClick}
                                height="100%"
                            />
                        </Box>
                    )}
                    {((role === "Admin" || roleType === "Team Leader") && activeTab === 1) || roleType === "Employee" ? (
                        <>
                            <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                                {
                                    role === "Admin" || roleType === "Team Leader" ? (
                                        <Table>
                                            <TableHead>
                                                <TableCell>S.No</TableCell>
                                                {/* <TableCell>Assigned User</TableCell> */}
                                                <TableCell>Lead Name</TableCell>
                                                <TableCell>Email</TableCell>
                                                <TableCell>Phone</TableCell>
                                                <TableCell>Package Type</TableCell>
                                                <TableCell>Keywords</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell></TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    assignedLeads.length === 0 ? (
                                                        <TableRow>
                                                            <TableCell colSpan={8} align="center">
                                                                No data found
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : (
                                                        assignedLeads?.map((task, id) => {
                                                            return (
                                                                <TableRow key={task?.id}>
                                                                    <TableCell>{calculateIndex(id)}</TableCell>
                                                                    {/* <TableCell>{task?.assignedTo?.name || task.name}</TableCell> */}
                                                                    <TableCell>{task?.name}</TableCell>
                                                                    <TableCell>{task?.email}</TableCell>
                                                                    <TableCell>{task?.phone}</TableCell>
                                                                    <TableCell>{task?.seoHistory?.seoPackageType}</TableCell>
                                                                    <TableCell>{task?.seoHistory?.targetKeywords}</TableCell>
                                                                    <TableCell>
                                                                        <Box position="relative" display="inline-flex">
                                                                            <CircularProgress
                                                                                variant="determinate"
                                                                                value={task?.seoHistory?.progress || 0}
                                                                            />
                                                                            <Box
                                                                                top={0}
                                                                                left={0}
                                                                                bottom={0}
                                                                                right={0}
                                                                                position="absolute"
                                                                                display="flex"
                                                                                alignItems="center"
                                                                                justifyContent="center"
                                                                            >
                                                                                <Typography variant="caption" component="div" color="text.secondary">
                                                                                    {`${Math.round(task?.seoHistory?.progress || 0)}%`}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <Iconify
                                                                            icon="material-symbols-light:more-vert"
                                                                            sx={{ margin: "auto" }}
                                                                            onClick={(event) => handleOpenMenu(event, task, task._id, task.seoHistory.dailyUpdateId)}
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        })
                                                    )
                                                }
                                            </TableBody>
                                        </Table>
                                    ) : roleType === "Employee" ? (
                                        <Table>
                                            <TableHead>
                                                <TableCell>S.No</TableCell>
                                                <TableCell>Name</TableCell>
                                                <TableCell>Contact</TableCell>
                                                <TableCell>Package Type</TableCell>
                                                <TableCell>Assigned Keywords</TableCell>
                                                {/* <TableCell>File Upload</TableCell> */}
                                                <TableCell>Deadline</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell></TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    assignedLeads?.length === 0 ? (
                                                        <TableRow>
                                                            <TableCell colSpan={8} align="center">
                                                                No data found
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : (
                                                        assignedLeads?.map((work, id) => {
                                                            // const seoData = work.seoHistory?.find(seo => seo.seoType === seoType) || {};
                                                            const seoData = work.seoHistory?.find(seo =>
                                                                seo.seoType?.some(type => seoType.includes(type))
                                                            ) || {};

                                                            return (
                                                                <TableRow key={work?.id}>
                                                                    <TableCell>{calculateIndex(id)}</TableCell>
                                                                    <TableCell>{work?.name}</TableCell>
                                                                    <TableCell>{work?.phone}</TableCell>
                                                                    <TableCell>{seoData?.seoPackageType || "-"}</TableCell>
                                                                    <TableCell align="center">{work?.currentWork?.noOfPosters || "-"}</TableCell>
                                                                    <TableCell align="center">
                                                                        {work?.currentWork?.deadline
                                                                            ? new Date(work.currentWork.deadline).toLocaleDateString()
                                                                            : "-"}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        <Box position="relative" display="inline-flex">
                                                                            <CircularProgress
                                                                                variant="determinate"
                                                                                value={seoData?.progress || 0}
                                                                            />
                                                                            <Box
                                                                                top={0}
                                                                                left={0}
                                                                                bottom={0}
                                                                                right={0}
                                                                                position="absolute"
                                                                                display="flex"
                                                                                alignItems="center"
                                                                                justifyContent="center"
                                                                            >
                                                                                <Typography variant="caption" component="div" color="text.secondary">
                                                                                    {`${Math.round(seoData?.progress || 0)}%`}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    </TableCell>

                                                                    <TableCell>
                                                                        <Iconify
                                                                            icon="material-symbols-light:more-vert"
                                                                            sx={{ margin: "auto" }}
                                                                            onClick={(event) => handleOpenMenu(event, work._id, seoData?.dailyUpdateId)}
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        })
                                                    )
                                                }
                                            </TableBody>
                                        </Table>
                                    ) : null
                                }
                            </TableContainer>

                            <PaginationComponent
                                name={"Leads"}
                                totalcount={totalCount}
                                limit={limit}
                                handleLimitChange={handleLimitChange}
                                handlePrevPage={handlePrevPage}
                                handleNextPage={handleNextPage}
                                currentPage={currentPage}
                                totalPages={totalPages}
                            />
                        </>
                    ) : null}
                </Card>

                {/* Edit Menu  */}
                <Popover
                    open={Boolean(openMenu)}
                    anchorEl={openMenu}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    {
                        role === "Admin" ? (
                            <MenuItem onClick={handleOpenDialog}>
                                <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                                View
                            </MenuItem>
                        ) : roleType === "Team Leader" ? (
                            <>
                                <MenuItem onClick={handleOpenDialog}>
                                    <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                                    View
                                </MenuItem>
                                <MenuItem onClick={() => handleFormOpen(selectedLeadId)}>
                                    <Iconify icon="material-symbols:sync-alt" sx={{ mr: 2 }} />
                                    Convert
                                </MenuItem>
                                <MenuItem onClick={() => handleOpenEdit(selectedLeadId)}>
                                    <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
                                    Edit
                                </MenuItem>
                            </>

                        ) : roleType === "Employee" ? (
                            <>
                                <MenuItem onClick={handleOpen}>
                                    <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                                    Work Update
                                </MenuItem>

                                <MenuItem sx={{ color: 'error.main' }}>
                                    <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                                    Delete
                                </MenuItem>
                            </>
                        ) : null
                    }
                </Popover>

                {/* View Dialog */}
                <Dialog
                    open={details}
                    onClose={handleCloseDialog}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    sx={{ maxWidth: 700, width: "100%", margin: "0 auto" }}
                >
                    <DialogTitle id="scroll-dialog-title">
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                            Daily Work Updates
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            component="div"
                        >
                            {!view || Object.keys(view).length === 0 ? (
                                <Box sx={{ p: 3, textAlign: 'center' }}>
                                    <Typography variant="h6" color="text.secondary">No data found</Typography>
                                </Box>
                            ) : (
                                <Box sx={{ p: 1 }}>
                                    <Paper elevation={3} sx={{
                                        p: 2,
                                        backgroundColor: '#ffffff',
                                        borderRadius: 2,
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                        borderLeft: '5px solid #1976d2' // A subtle accent line
                                    }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Project Details
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Name: {view?.name}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Package Type: {view?.seoHistory?.seoPackageType}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    {/* Deadline: {new Date(view?.seoHistory?.deadline).toLocaleDateString()} */}
                                                    Business Profile Availability: {view?.seoHistory?.businessProfileAvailability}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    {/* Deadline: {new Date(view?.seoHistory?.deadline).toLocaleDateString()} */}
                                                    Business Profile Duration: {new Date(view?.seoHistory?.businessProfileDuration).toLocaleDateString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Website Availability: {view?.seoHistory?.websiteAvailability}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Website Duration: {new Date(view?.seoHistory?.websiteDuration).toLocaleDateString()}
                                                </Typography>
                                            </Grid>
                                            {role === "Admin" && (
                                                <Grid item xs={12} sm={6} id="paddingTop">
                                                    <Typography variant="body1">
                                                        Paid Amount: {view?.seoHistory?.amount}
                                                    </Typography>
                                                </Grid>
                                            )}
                                            {role === "Admin" && (
                                                <Grid item xs={12} sm={6} id="paddingTop">
                                                    <Typography variant="body1">
                                                        Payment Status: <Typography component="span" sx={{
                                                            fontWeight: 'bold',
                                                            color: view?.seoHistory?.paymentStatus === 'Completed' ? 'success.main' :
                                                                view?.seoHistory?.paymentStatus === 'In Progress' ? 'warning.main' : 'error.main'
                                                        }}>
                                                            {view?.seoHistory?.paymentStatus}
                                                        </Typography>
                                                    </Typography>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Task Progress
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Target Keywords: {view?.seoHistory?.targetKeywords}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Target Location: {view?.seoHistory?.targetLocation}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Total Keywords: {view?.seoHistory?.totalKeywords}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Completed Keywords: {view?.seoHistory?.completedKeywords}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                        {view?.seoHistory?.completionPercentage ? view?.seoHistory?.completionPercentage : 0}%
                                                    </Typography>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Status: <Typography component="span" sx={{
                                                        fontWeight: 'bold',
                                                        color: view?.seoHistory?.status === 'Completed' ? 'success.main' :
                                                            view?.seoHistory?.status === 'In Progress' ? 'warning.main' : 'error.main'
                                                    }}>
                                                        {view?.seoHistory?.status}
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            {view?.[0]?.seoHistory?.comments && (
                                                <Grid item xs={12} id="paddingTop">
                                                    <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#333' }}>
                                                        Comments
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                                                        "{view?.[0]?.seoHistory?.comments}"
                                                    </Typography>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Timestamps
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Created: {new Date(view?.createdAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Updated: {new Date(view?.updatedAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Box>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={handleCloseDialog} variant="contained" color="primary">Close</Button>
                    </DialogActions>
                </Dialog>

                {/* Work Update Form Dialog */}
                <Dialog
                    open={formOpen}
                    onClose={handleClose}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">Daily Work Update!</DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                        >
                            <TextField
                                margin="dense"
                                label="Completed Tasks"
                                name="completedKeywords"
                                value={formData.completedKeywords}
                                onChange={handleChange}
                                type="number"
                                fullWidth
                            />

                            <TextField
                                margin="dense"
                                label="Comments"
                                name="comments"
                                value={formData.comments}
                                onChange={handleChange}
                                multiline
                                fullWidth
                            />
                            <TextField
                                margin='dense'
                                type='file'
                                hidden
                                label="Upload File"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => handleFileChange(e)}
                            >
                            </TextField>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button onClick={postDailyWorkUpdate}>Submit</Button>
                    </DialogActions>
                </Dialog>

                {/* Assign Leads Dialog */}
                <Dialog open={convertForm}>
                    <DialogTitle>Assign SEO Lead</DialogTitle>
                    <DialogContent>
                        <FormControl fullWidth margin="dense">
                            <InputLabel id="assign-to-label">Assign To</InputLabel>
                            <Select
                                labelId="assign-to-label"
                                multiple
                                value={convertData.assignedTo}
                                onChange={handleMultiSelectChange}
                                InputLabelProps={{ shrink: true }}
                                label="Assign To"
                                input={<OutlinedInput label="Assign To" />}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => {
                                            const employee = employeeOptions.find(emp => emp.id === value);
                                            return employee ? (
                                                <Chip key={value} label={employee.name} />
                                            ) : null;
                                        })}
                                    </Box>
                                )}
                                fullWidth
                            >
                                {employeeOptions.map((emp) => (
                                    <MenuItem key={emp.id} value={emp.id}>
                                        {emp.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Box sx={{ mt: 2 }}>
                            {convertData.assignedTo.map((empId) => {
                                const employee = employeeOptions.find(emp => emp.id === empId);
                                return (
                                    <>
                                        <Box key={empId} sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 2 }}>
                                            <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                                                <div className='col' style={{ marginTop: "5px" }}>
                                                    <Typography>{employee?.name}</Typography>
                                                </div>
                                            </div>
                                        </Box>
                                        <Box key={empId} sx={{ alignItems: 'center', mb: 1, gap: 2 }}>
                                            <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "10px" }}>
                                                <TextField
                                                    label="No of Keywords"
                                                    value={convertData.employeeWork?.[empId]?.noOfPosters || ""}
                                                    onChange={(e) => {
                                                        const work = e.target.value;
                                                        setConvertData(prev => ({
                                                            ...prev,
                                                            employeeWork: {
                                                                ...prev.employeeWork,
                                                                [empId]: {
                                                                    ...prev.employeeWork?.[empId],
                                                                    noOfPosters: work
                                                                }
                                                            }
                                                        }));
                                                    }}
                                                    size="small"
                                                    fullWidth
                                                />
                                                <TextField
                                                    label="Deadline"
                                                    value={convertData.employeeWork?.[empId]?.deadline || ""}
                                                    onChange={(e) => {
                                                        const work = e.target.value;
                                                        setConvertData(prev => ({
                                                            ...prev,
                                                            employeeWork: {
                                                                ...prev.employeeWork,
                                                                [empId]: {
                                                                    ...prev.employeeWork?.[empId],
                                                                    deadline: work
                                                                }
                                                            }
                                                        }));
                                                    }}
                                                    type='date'
                                                    size="small"
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </div>
                                            {/* <FormControl fullWidth margin="dense">
                                                <InputLabel id="seo-type-label">SEO Type</InputLabel>
                                                <Select
                                                    labelId="seo-type-label"
                                                    value={seoType}
                                                    onChange={(e) => {
                                                        setSeoType(e.target.value);
                                                        setConvertData(prev => ({ ...prev, seoType: e.target.value }));
                                                    }}
                                                    label="SEO Type"
                                                >
                                                    <MenuItem value="Goole Business Profile">Goole Business Profile</MenuItem>
                                                    <MenuItem value="Website SEO">Website SEO</MenuItem>
                                                </Select>
                                            </FormControl> */}
                                        </Box>
                                    </>
                                );
                            })}
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleFormClose} color="secondary">Cancel</Button>
                        <Button onClick={convertLeads} color="primary">Submit</Button>
                    </DialogActions>
                </Dialog>

                {/* Edit Dialog */}
                <Dialog
                    open={editOpen}
                    onClose={handleCloseEdit}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">Edit</DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                        >
                            <TextField
                                margin="dense"
                                select
                                label="SEO Type"
                                name="seoType"
                                value={editData.seoType}
                                onChange={handleServiceChange}
                                fullWidth
                                SelectProps={{
                                    multiple: true,
                                    renderValue: (selected) => Array.isArray(selected) ? selected.join(', ') : ''
                                }}
                            >
                                <MenuItem value="Google Business Profile">Google Business Profile</MenuItem>
                                <MenuItem value="Website SEO">Website SEO</MenuItem>
                            </TextField>
                            <TextField margin="dense" select label="Business Profile Availability" name="businessProfileAvailability" value={editData.businessProfileAvailability || ''} onChange={handleServiceChange} fullWidth>
                                <MenuItem value="Yes">Yes</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                            </TextField>
                            <TextField margin="dense" select label="Website Availability" name="websiteAvailability" value={editData.websiteAvailability || ''} onChange={handleServiceChange} fullWidth>
                                <MenuItem value="Yes">Yes</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                            </TextField>
                            <TextField margin="dense" label="Website SEO Duration" name="websiteDuration" type="date" InputLabelProps={{ shrink: true }} value={editData.websiteDuration || ''} onChange={handleServiceChange} fullWidth />
                            <TextField margin="dense" label="Business Profile Duration" name="businessProfileDuration" type="date" InputLabelProps={{ shrink: true }} value={editData.businessProfileDuration || ''} onChange={handleServiceChange} fullWidth />
                            <TextField margin="dense" label="Target Location" name="targetLocation" value={editData.targetLocation || ''} onChange={handleServiceChange} fullWidth />
                            <TextField margin="dense" label="Target Keywords" name="targetKeywords" value={editData.targetKeywords || ''} onChange={handleServiceChange} fullWidth />
                            <TextField margin="dense" label="Total Keywords" name="totalKeywords" value={editData.totalKeywords || ''} onChange={handleServiceChange} fullWidth />
                            <TextField margin="dense" select label="Back Link Status" name="backlinkStatus" value={editData.backlinkStatus || ''} onChange={handleServiceChange} fullWidth>
                                <MenuItem value="No Backlinks">No Backlinks</MenuItem>
                                <MenuItem value="Low">Low</MenuItem>
                                <MenuItem value="Moderate">Moderate</MenuItem>
                                <MenuItem value="High">High</MenuItem>
                            </TextField>
                            <TextField margin="dense" select label="Package Type" name="seoPackageType" value={editData.seoPackageType || ''} onChange={handleServiceChange} fullWidth>
                                <MenuItem value="3 months">3 Months</MenuItem>
                                <MenuItem value="4 months">4 Months</MenuItem>
                                <MenuItem value="6 months">6 Months</MenuItem>
                                <MenuItem value="1 year">1 Year</MenuItem>
                            </TextField>
                            <FormControl fullWidth margin="dense">
                                <InputLabel id="assign-to-label">Assign To</InputLabel>
                                <Select
                                    name='assignedTo'
                                    labelId="assign-to-label"
                                    value={editData.assignedTo || ""}
                                    onChange={handleServiceChange}
                                    InputLabelProps={{ shrink: true }}
                                    label="Assign To"
                                    input={<OutlinedInput label="Assign To" />}
                                    fullWidth
                                >
                                    {employeeOptions.map((emp) => (
                                        <MenuItem key={emp.id} value={emp.id}>
                                            {emp.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <TextField
                                margin='dense'
                                label="Amount"
                                name="seoPaidAmount"
                                value={editData.amount || ''}
                                onChange={handleServiceChange}
                                type="number"
                                fullWidth
                            />
                            <TextField margin="dense" select label="Payment Status" name="seoPaymentStatus" value={editData.paymentStatus || ''} onChange={handleServiceChange} fullWidth>
                                {["Pending", "Completed"].map(p => (
                                    <MenuItem key={p} value={p}>{p}</MenuItem>
                                ))}
                            </TextField>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseEdit}>Cancel</Button>
                        <Button onClick={handleSubmit}>Submit</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={openReminderDialog} onClose={handleCloseReminderDialog}>
                    <DialogTitle>{selectedReminder?.reminderMessage}</DialogTitle>
                    <DialogContent>
                        {selectedReminder && (
                            <Box sx={{ p: 1 }}>
                                <Paper elevation={3} sx={{
                                    p: 2,
                                    backgroundColor: '#ffffff',
                                    borderRadius: 2,
                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                    borderLeft: '5px solid #1976d2'
                                }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Name: {selectedReminder?.leadName}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                SEO Type: {selectedReminder?.seoType}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Package Type: {selectedReminder?.seoPackageType}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Business Profile Deadline: {new Date(selectedReminder?.businessProfileDeadline).toLocaleDateString()}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Website Deadline: {new Date(selectedReminder?.websiteDuration).toLocaleDateString()}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Status: <Typography component="span" sx={{
                                                    fontWeight: 'bold',
                                                    color: selectedReminder?.status === 'Completed' ? 'success.main' :
                                                        selectedReminder?.status === 'In Progress' ? 'warning.main' : 'error.main'
                                                }}>
                                                    {selectedReminder?.status}
                                                </Typography>
                                            </Typography>
                                        </Grid>
                                        {/* <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Reminder Message: {selectedReminder?.reminderMessage}
                                            </Typography>
                                        </Grid> */}
                                        <Grid item xs={12} sm={6} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Completed Keywords: {selectedReminder?.completedKeywords}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Total Keywords: {selectedReminder?.totalKeywords}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                    {selectedReminder?.completionPercentage}%
                                                </Typography>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                Created: {new Date(selectedReminder?.createdAt).toLocaleString()}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                Updated: {new Date(selectedReminder?.updatedAt).toLocaleString()}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseReminderDialog} color="secondary">Close</Button>
                        <Button onClick={handleMarkReminderCompleted} color="primary">Mark as Completed</Button>
                    </DialogActions>
                </Dialog>

            </Container>
        </>
    );
}

function renderEventContent(eventInfo) {
    const isDeadline = eventInfo.event.extendedProps.type === 'deadline';
    const extendedProps = eventInfo.event.extendedProps;

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: isDeadline ? '#FFEBEE' : '#F5F5F5',
            borderRadius: '8px',
            padding: '6px',
            marginTop: '5px',
            boxShadow: 2,
            fontSize: '12px',
            color: 'black',
            maxWidth: "125px",
            borderLeft: `4px solid ${extendedProps.color || eventInfo.event.backgroundColor || '#90CAF9'}`,
            wordWrap: extendedProps ? 'break-word' : 'normal',
            whiteSpace: extendedProps ? 'normal' : 'nowrap',
            overflowWrap: extendedProps ? 'anywhere' : 'normal',

        }}>
            <Box sx={{
                paddingLeft: '6px'
            }}>
                {isDeadline && (
                    <>
                        <strong>⏰</strong>
                        <div>Lead: {eventInfo.event.extendedProps.leadName}</div>
                        <div>Progress: {eventInfo.event.extendedProps.progress}</div>
                    </>
                )}
                {
                    !isDeadline && extendedProps && (
                        <>
                            <strong>📝 {eventInfo.event.title}</strong>
                        </>
                    )
                }
            </Box>
        </Box>
    );
}

export default SEO;
